const raf = (cb) => globalThis.requestAnimationFrame(cb)

export const createScrollHub = () => {
  const state = {
    scroll: 0,
    isQueued: false,
    scrollingElement: null,
    unbindHandlers: new Map(),
    watchers: new Map(),
  }

  const onScroll = () => {
    if (state.isQueued) return
    state.isQueued = true
    raf(onUpdate)
  }

  const onUpdate = () => {
    if (!state.isQueued) return
    state.scroll += 1
    state.isQueued = false
    state.watchers.forEach((handler) => handler(state.scroll))
  }

  const triggerUpdate = (delay = 0) => {
    setTimeout(onUpdate, delay)
  }

  const init = (scrollingElement, scrollEventTarget) => {
    if (state.scrollingElement) return
    const scrollEventElement = scrollEventTarget || scrollingElement
    state.scrollingElement = scrollingElement
    scrollEventElement.addEventListener('scroll', onScroll)
  }

  const bind = (uid, handler) => {
    state.watchers.set(uid, handler)
    handler(state.scroll)
    state.unbindHandlers.set(uid, () => {
      state.watchers.delete(uid)
    })
  }

  const unbind = (uid) => {
    const cleanup = state.unbindHandlers.get(uid)
    if (cleanup) {
      cleanup()
      state.unbindHandlers.delete(uid)
    }
  }

  const isUnique = (uid) => !state.watchers.has(uid)

  return {
    get scroll() {
      return state.scroll
    },
    init,
    bind,
    unbind,
    isUnique,
    triggerUpdate,
    onUpdate,
  }
}

let scrollHubInstance = null

const scrollHubFactory = () => {
  scrollHubInstance = createScrollHub()
  return scrollHubInstance
}

export const getInstance = () => scrollHubInstance

export default scrollHubFactory
